import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2359a0fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dw-sidebar-couriers-courier__header" }
const _hoisted_2 = ["fill", "stroke"]
const _hoisted_3 = ["fill", "stroke"]
const _hoisted_4 = ["fill", "stroke"]
const _hoisted_5 = ["fill", "stroke"]
const _hoisted_6 = ["fill", "stroke"]
const _hoisted_7 = ["fill", "stroke"]
const _hoisted_8 = { class: "header__name" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12.6668 6L8.00016 10.6667L3.3335 6",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_10 = {
  key: 0,
  class: "dw-sidebar-couriers-courier__container"
}
const _hoisted_11 = { class: "container__entities" }
const _hoisted_12 = {
  key: 0,
  class: "entities__state"
}
const _hoisted_13 = {
  key: 1,
  class: "entities__count"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dw_sidebar_entity = _resolveComponent("dw-sidebar-entity")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["dw-sidebar-couriers-courier", { 'courier--opened': _ctx.state.is_opened }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createElementBlock("svg", {
        class: "header__route",
        width: "32",
        height: "16",
        viewBox: "0 0 32 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onShowRoute && _ctx.onShowRoute(...args)))
      }, [
        _createElementVNode("rect", {
          x: "0.5",
          y: "0.5",
          width: "31",
          height: "15",
          rx: "7.5",
          fill: _ctx.routeShowed ? _ctx.courier.localColor as string : 'none',
          stroke: (_ctx.courier.localColor as string)
        }, null, 8, _hoisted_2),
        _createElementVNode("path", {
          d: "M10.3883 6.03158L12.1524 8.92607C11.955 9.06184 11.825 9.28934 11.825 9.54688C11.825 9.96219 12.1628 10.3 12.5781 10.3C12.893 10.3 13.163 10.1058 13.2754 9.83125H15.0625C15.4226 9.83125 15.7156 10.1243 15.7156 10.4844C15.7156 10.8445 15.4226 11.1375 15.0625 11.1375H12.25C11.5762 11.1375 11.0281 11.6856 11.0281 12.3594C11.0281 13.0332 11.5762 13.5813 12.25 13.5813H14.5938C14.7508 13.5813 14.8781 13.4539 14.8781 13.2969C14.8781 13.1398 14.7508 13.0125 14.5938 13.0125H12.25C11.8899 13.0125 11.5969 12.7195 11.5969 12.3594C11.5969 11.9993 11.8899 11.7063 12.25 11.7063H15.0625C15.7363 11.7063 16.2844 11.1582 16.2844 10.4844C16.2844 9.81059 15.7363 9.2625 15.0625 9.2625H13.2754C13.2193 9.12557 13.1242 9.0088 13.0038 8.92607L14.768 6.03159C15.0547 5.60026 15.2063 5.09771 15.2063 4.57812C15.2063 3.12893 14.0273 1.95 12.5781 1.95C11.1289 1.95 9.95 3.12893 9.95 4.57812C9.95 5.09771 10.1016 5.60026 10.3883 6.03158ZM12.5781 9.73125C12.4765 9.73125 12.3937 9.6485 12.3937 9.54688C12.3937 9.44525 12.4765 9.3625 12.5781 9.3625C12.6797 9.3625 12.7625 9.44525 12.7625 9.54688C12.7625 9.6485 12.6797 9.73125 12.5781 9.73125ZM12.5781 2.51875C13.7136 2.51875 14.6375 3.44263 14.6375 4.57812C14.6375 4.98706 14.5179 5.38208 14.2917 5.7207L14.2853 5.73068L14.2852 5.73082L12.5781 8.5317L12.5455 8.47814L12.3468 8.15224L11.7439 7.16311C11.3074 6.447 10.8689 5.72754 10.8646 5.7207C10.6383 5.38208 10.5188 4.98706 10.5188 4.57812C10.5188 3.44263 11.4426 2.51875 12.5781 2.51875Z",
          fill: _ctx.routeShowed ? 'white': (_ctx.courier.localColor as string),
          stroke: _ctx.routeShowed ? 'white': (_ctx.courier.localColor as string),
          "stroke-width": "0.1"
        }, null, 8, _hoisted_3),
        _createElementVNode("path", {
          d: "M12.5781 5.8C13.2519 5.8 13.8 5.25191 13.8 4.57812C13.8 3.90434 13.2519 3.35625 12.5781 3.35625C11.9043 3.35625 11.3562 3.90434 11.3562 4.57812C11.3562 5.25191 11.9043 5.8 12.5781 5.8ZM12.5781 3.925C12.9382 3.925 13.2313 4.21804 13.2313 4.57812C13.2313 4.93821 12.9382 5.23125 12.5781 5.23125C12.218 5.23125 11.925 4.93821 11.925 4.57812C11.925 4.21804 12.218 3.925 12.5781 3.925Z",
          fill: _ctx.routeShowed ? 'white': (_ctx.courier.localColor as string),
          stroke: _ctx.routeShowed ? 'white': (_ctx.courier.localColor as string),
          "stroke-width": "0.1"
        }, null, 8, _hoisted_4),
        _createElementVNode("path", {
          d: "M21.1354 9.61132L21.1351 9.61185L20.2569 10.9893L19.6538 11.9353L19.4551 12.247L19.4219 12.2991L19.3887 12.247L19.1899 11.9353L18.5868 10.9892L17.7085 9.61153L17.7083 9.61133C17.4821 9.27271 17.3625 8.87768 17.3625 8.46875C17.3625 7.33325 18.2864 6.40938 19.4219 6.40938C20.5574 6.40938 21.4812 7.33325 21.4812 8.46875C21.4812 8.87768 21.3617 9.27271 21.1354 9.61132ZM19.4219 5.84062C17.9727 5.84062 16.7937 7.01956 16.7937 8.46875C16.7937 8.98933 16.9459 9.4928 17.2337 9.92468L18.9902 12.68C18.8727 12.7625 18.7798 12.8778 18.7247 13.0125H16.7031C16.5461 13.0125 16.4187 13.1398 16.4187 13.2969C16.4187 13.4539 16.5461 13.5813 16.7031 13.5813H18.7246C18.837 13.8558 19.107 14.05 19.4219 14.05C19.8372 14.05 20.175 13.7122 20.175 13.2969C20.175 13.0419 20.0477 12.8163 19.8535 12.68L21.6101 9.92467C21.8979 9.4928 22.05 8.98933 22.05 8.46875C22.05 7.01956 20.8711 5.84062 19.4219 5.84062ZM19.4219 13.4812C19.3203 13.4812 19.2375 13.3985 19.2375 13.2969C19.2375 13.1953 19.3203 13.1125 19.4219 13.1125C19.5235 13.1125 19.6063 13.1953 19.6063 13.2969C19.6063 13.3985 19.5235 13.4812 19.4219 13.4812Z",
          fill: _ctx.routeShowed ? 'white': (_ctx.courier.localColor as string),
          stroke: _ctx.routeShowed ? 'white': (_ctx.courier.localColor as string),
          "stroke-width": "0.1"
        }, null, 8, _hoisted_5),
        _createElementVNode("path", {
          d: "M19.4219 7.24687C18.7481 7.24687 18.2 7.79496 18.2 8.46875C18.2 9.14254 18.7481 9.69062 19.4219 9.69062C20.0957 9.69062 20.6437 9.14254 20.6437 8.46875C20.6437 7.79496 20.0957 7.24687 19.4219 7.24687ZM19.4219 9.12188C19.0618 9.12188 18.7688 8.82884 18.7688 8.46875C18.7688 8.10866 19.0618 7.81563 19.4219 7.81563C19.782 7.81563 20.075 8.10866 20.075 8.46875C20.075 8.82884 19.782 9.12188 19.4219 9.12188Z",
          fill: _ctx.routeShowed ? 'white': (_ctx.courier.localColor as string),
          stroke: _ctx.routeShowed ? 'white': (_ctx.courier.localColor as string),
          "stroke-width": "0.1"
        }, null, 8, _hoisted_6),
        _createElementVNode("path", {
          d: "M15.6484 13.5813C15.8055 13.5813 15.9328 13.4539 15.9328 13.2969C15.9328 13.1398 15.8055 13.0125 15.6484 13.0125C15.4914 13.0125 15.3641 13.1398 15.3641 13.2969C15.3641 13.4539 15.4914 13.5813 15.6484 13.5813Z",
          fill: _ctx.routeShowed ? 'white': (_ctx.courier.localColor as string),
          stroke: _ctx.routeShowed ? 'white': (_ctx.courier.localColor as string),
          "stroke-width": "0.1"
        }, null, 8, _hoisted_7)
      ])),
      _createElementVNode("div", {
        class: "header__container",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
      }, [
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.courier.courierName), 1),
        _hoisted_9
      ])
    ]),
    (_ctx.state.is_opened)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            (_ctx.computedOrders.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, " Список пуст "))
              : (_openBlock(), _createElementBlock("div", _hoisted_13, " Количество: " + _toDisplayString(_ctx.computedOrders.length), 1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computedOrders, (item) => {
              return (_openBlock(), _createBlock(_component_dw_sidebar_entity, {
                "is-courier-item": "",
                key: item.type === 1 ? (item as DispatcherWorkplaceTake).orderId : (item as DispatcherWorkplaceDelivery).invoiceId,
                entity: item,
                "selected-feature-id": _ctx.selectedSidebarFeatureId,
                onClick: _ctx.onEntityClicked
              }, null, 8, ["entity", "selected-feature-id", "onClick"]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}